import React from 'react';
import { Shield, Award, CheckCircle, Building2 } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    { icon: Shield, label: 'ISO 9001:2015 Certified' },
    { icon: Award, label: 'Government Approved Vendor' },
    { icon: CheckCircle, label: 'Quality Assured' },
    { icon: Building2, label: 'Enterprise Grade' }
  ];

  return (
    <section className="bg-gray-50 py-8 border-y border-gray-100" data-testid="trust-badges">
      <div className="container-custom">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-gray-600"
              data-testid={`trust-badge-${index}`}
            >
              <badge.icon className="w-5 h-5 text-[#003151]" />
              <span className="text-sm font-medium">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
